import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import { useSearchParam } from 'react-use'
import type { PivotLayout } from '@ztechapps/common.contract'
import type { OnChangeTemplateFunction } from './index'
import { useDeepCompareEffect, useTemplateDocument } from '@ztechapps/common.hook'
import { parsePivotLayout } from '../pivot/parsePivotLayout'

export type UsePivotDefaultTemplateResult = {
  defaultLayout: PivotLayout | undefined
  loading: boolean
}

export const usePivotDefaultTemplate = ({
  templateCategory,
  onChangeTemplate,
  onApplyFilterTemplate,
}: {
  templateCategory?: string
  onChangeTemplate?: OnChangeTemplateFunction
  onApplyFilterTemplate?: (filterTemplateId: string) => void
} = {}): UsePivotDefaultTemplateResult => {
  const pivotTemplateId = useSearchParam('templateId')

  //we need to get the default filter template initially here
  //but when the pivotTemplateId is available use it
  const pivotTemplateFilter = pivotTemplateId
    ? { _id: pivotTemplateId }
    : { category: templateCategory, isDefault: true }

  const { document, loading } = useTemplateDocument({
    filter: pivotTemplateFilter,
  })

  // the empty layout when no template exists; undefined while the lookup is still running
  const defaultLayout = useMemo(
    () => (loading ? undefined : parsePivotLayout(document?.value)),
    [loading, document?.value]
  )

  useDeepCompareEffect(() => {
    if (!isEmpty(document?.value)) {
      //set also the pivot template here
      onChangeTemplate?.({ template: document })
      if (document.autoApplyFilterTemplate && document.filterTemplateId)
        onApplyFilterTemplate?.(document.filterTemplateId)
    }
  }, [document])

  return {
    defaultLayout,
    loading,
  }
}
